<div class="container">
  <div class="table-header col-12 position-relative">
    <rask-header size="4">
      <span>{{ handelssortimentsgrupp.grupp }}</span>
      @if (!arbetsorderWrapper.arbetsorder.isExternArbetsorder) {
        <rask-action-button
          icon="far fa-edit"
          [disabled]="!canEdit"
          (click)="showTree($event)">
          Redigera
        </rask-action-button>
      }
      @if (handelssortimentSelectionItems) {
        <rask-tree-selector class="tree-selector" #tree
          [visibilityControlledByCaller]="true"
          aid="produktval-handelssortiment-selector"
          [items]="handelssortimentSelectionItems"
          emptyText="Inga handelssortiment"
          [autoSort]="true"
          (onSelectionEvent)="onTreeSelectionEvent($event)"
          [sortExpression]="treeSelectorSortExpression">
        </rask-tree-selector>
      }
    </rask-header>
  </div>
  @if (hasRows) {
    <div>
      <div>
        @for (row of selectedRows; track row; let i = $index) {
          <div class="content">
            <div>
              <div class="row header">
                <div class="col-7 svea-text" nowrap>{{ row.text }}</div>
                <div class="col-2 svea-text" nowrap>
                </div>
              </div>
              <div class="header-right-container col-2">
                <rask-input-number
                  aid="justera-kvantitet"
                  [(ngModel)]="row.kvantitet"
                  [disabled]="!canEdit()"
                  (ngModelChange)="onAngivenKvantitetChange($event, row)"
                  [min]="0"
                  >
                </rask-input-number>
              </div>
            </div>
            <div class="row collapse" id="collapse_" [ngbCollapse]="row.collapsed">
              <div class="col-7 offset-1">
              </div>
              <div class="col-4">
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
